import { createRouter, createWebHistory } from 'vue-router'

import AuthMiddleware from '@/middleware/authMiddleware'
import GuestMiddleware from '@/middleware/guestMiddleware'

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import EmptyLayout from '@/layouts/EmptyLayout.vue'

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('@/components/Dashboard/Dashboard.vue'),
    meta: {
      layout: DefaultLayout,
      middleware: AuthMiddleware,
      breadcrumb: 'Дашборд',
    },
  },
  {
    path: '/new-ticket',
    name: 'new-ticket',
    component: () => import('@/components/NewTicket.vue'),
    meta: {
      layout: DefaultLayout,
      middleware: AuthMiddleware,
      breadcrumb: 'Новая заявка',
    },
  },
  {
    path: '/ticket',
    name: 'ticket',
    component: () => import('@/components/Ticket/Ticket.vue'),
    meta: {
      layout: DefaultLayout,
      middleware: AuthMiddleware,
      breadcrumb: 'Заявка',
    },
  },
  {
    path: '/status-board',
    name: 'statusBoard',
    component: () => import('@/components/StatusBoard/StatusBoard.vue'),
    meta: {
      layout: DefaultLayout,
      middleware: AuthMiddleware,
      breadcrumb: 'Статус диспетчера',
    },
  },
  {
    path: '/client-details',
    name: 'clientDetails',
    component: () => import('@/components/ClientDetails/ClientDetails.vue'),
    meta: {
      layout: DefaultLayout,
      middleware: AuthMiddleware,
      breadcrumb: 'Информация о клиенте',
    },
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/components/Settings/UserSettings.vue'),
    meta: {
      layout: DefaultLayout,
      middleware: AuthMiddleware,
      breadcrumb: 'Настройки / Профиль пользователя ',
    },
  },
  {
    path: '/calls',
    name: 'calls',
    component: () => import('@/components/Path2.vue'),
    meta: {
      layout: DefaultLayout,
      middleware: AuthMiddleware,
      breadcrumb: 'Вызовы',
    },
  },
  {
    path: '/tickets-list',
    name: 'ticketsList',
    component: () => import('@/components/TicketsList/TicketsList.vue'),
    meta: {
      layout: DefaultLayout,
      middleware: AuthMiddleware,
      breadcrumb: 'Список заявок',
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/pages/LoginPage.vue'),
    meta: {
      layout: EmptyLayout,
      middleware: GuestMiddleware,
    },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/pages/NotFound.vue'),
    meta: {
      layout: EmptyLayout,
    },
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

function nextFactory(context, middleware, index) {
  const subsequentMiddleware = middleware[index]
  if (!subsequentMiddleware) {
    return context.next
  }

  return (...parameters) => {
    context.next(...parameters)
    const nextMiddleware = nextFactory(context, middleware, index + 1)
    subsequentMiddleware({ ...context, next: nextMiddleware })
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.middleware) {
    const middleware = Array.isArray(to.meta.middleware) ? to.meta.middleware : [to.meta.middleware]
    const context = { from, next, router, to }
    const nextMiddleware = nextFactory(context, middleware, 1)

    middleware[0]({ ...context, next: nextMiddleware })
  }
  else {
    next()
  }
})

export default router
